export enum AlertColor {
  RED,
  GREEN,
}
